import { lazy } from 'react';

export const BimCalculationPreview = lazy(() =>
    import('./BimCalculationPreview').then((module) => ({ default: module.BimCalculationPreview })),
);
